import {CTWorkOrderRow} from "./ct-work-order.row";

export class CtWorkOrderRowContact extends CTWorkOrderRow {

  Contact: any;

  public static override create = (model?: CTWorkOrderRow) => <CtWorkOrderRowContact>CTWorkOrderRow.create(model);

}
